import { createFileRoute } from "@tanstack/react-router";
import { PolicyPage, policyHead } from "../pages/PolicyPage";

export const Route = createFileRoute("/about-us")({
  head: () => policyHead("about"),
  component: () => <PolicyPage page="about" />
});
